import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Row, Col } from "components/bootstrap";
import { DocumentTitle, PageHeader, Spinner, Link } from "components/common";
import PageNavigation from "components/common/PageNavigation";
import AppConfig from "util/AppConfig";
import DocsHelper from "util/DocsHelper";
import useProductName from "brand-customization/useProductName";
import { InputsOverview } from "components/inputs/InputsOveriew";
import useInputTypes from "hooks/useInputTypes";
import Routes from "routing/Routes";
import useInputTypesDescriptions from "hooks/useInputTypesDescriptions";
import InputsNotifications from "components/inputs/InputsNotifications";
const isCloud = AppConfig.isCloud();
export const INPUTS_PAGE_NAV_TITLE = "Inputs";
const InputsPage = () => {
  const { t } = useTranslation("inputs");
  const productName = useProductName();
  const { data: inputTypes, isLoading: isLoadingInputTypes } = useInputTypes();
  const { data: inputTypeDescriptions, isLoading: isLoadingInputTypesDescriptions } = useInputTypesDescriptions();
  if (isLoadingInputTypes || isLoadingInputTypesDescriptions) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("pages.inputs") }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(PageNavigation, { page: INPUTS_PAGE_NAV_TITLE })), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: t("pages.inputs"),
      documentationLink: {
        title: t("pages.docs"),
        path: DocsHelper.PAGES.INPUTS
      }
    },
    isCloud ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, t("pages.cloud_description", { productName })), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "pages.cloud_forwarder_hint",
        components: { forwarderLink: /* @__PURE__ */ React.createElement(Link, { to: Routes.SYSTEM.FORWARDERS }) }
      }
    ))) : /* @__PURE__ */ React.createElement("span", null, t("pages.description", { productName }))
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(InputsNotifications, null), /* @__PURE__ */ React.createElement(InputsOverview, { inputTypeDescriptions, inputTypes }))));
};
export default InputsPage;
